import React from "react";
import { useRoutes } from "react-router-dom";
import { DashboardRoutesList } from "../Dashboard/DashboardRoutes";
import { ADMIN_ROUTES } from "../RoutesEnum";
//import "./index.scss";

const AdminLayout = React.lazy(() => import("../../layouts/AdminLayout"));
const UserManagementPage = React.lazy(() => import("../../pages/AdminPanel/UserManagementPage"));
const DashboardLayout = React.lazy(() => import("../../layouts/DashboardLayout"));

const AdminPanelRoutes = ({ baseUri = `${process.env.PUBLIC_URL}` }) => {
  const adminRoutes = [
    {
      path: `${process.env.PUBLIC_URL}`,
      element: <DashboardLayout />
    },
    {
      path: `${process.env.PUBLIC_URL}${ADMIN_ROUTES.ROOT}`,
      element: <AdminLayout />,
      children: [
        {
          path: "user/management",
          element: <UserManagementPage />,
        },
      ],
    },
    /*{
      path: `${process.env.PUBLIC_URL}/`,
      element: <DashboardLayout />
    }*/
  ]
  //console.log("AdminPanelRoutes INIT", { adminRoutes, DashboardRoutesList: DashboardRoutesList(baseUri), baseUri })
  const routes = useRoutes([...adminRoutes, ...DashboardRoutesList(baseUri)]);
  return routes;
};

export default AdminPanelRoutes;

